import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    CommandSurfaceColorConstantType,
    CommandSurfaceConstantType,
    CommandDynamicStyleType,
    CommandVariant
} from "./type";
import type {
    Mutable
} from "../../types";
import type {
    PopoverSurfaceSearchSize
} from "../popoverSurface/components/search/type";
import {
    SURFACE_CONTAINER_COLOR,
    getSurfaceStyle
} from "../../helpers/theme/elevation";
import {
    getCornerStyle
} from "../../helpers/theme/corner";
import {
    webStyle
} from "../../utils";

export const COMMAND_LIST_MAX_ROWS: Record<CommandVariant, number> = {
    inline: 100,
    dialog: 12,
    sheet: 100
};

export const COMMAND_SEARCH_SIZES: Record<CommandVariant, PopoverSurfaceSearchSize> = {
    inline: "medium",
    dialog: "large",
    sheet: "large"
};

export const COMMAND_PAGE_STEP = 8;

export const getCommandSurfaceColor = ({
    surfaceColor,
    variant
}: CommandSurfaceColorConstantType): keyof NCoreUIKit.ContainerContentColors => {
    if(variant === "dialog") {
        return SURFACE_CONTAINER_COLOR;
    }

    if(variant === "sheet") {
        return "default";
    }

    return surfaceColor;
};

export const getCommandSurfaceStyle = ({
    shapeConfigs,
    shadowAlpha,
    windowWidth,
    elevations,
    radiuses,
    borders,
    variant,
    colors,
    spaces
}: CommandSurfaceConstantType): ViewStyle => {
    const style: Mutable<ViewStyle> = {
        padding: spaces.spacingXs
    };

    if(variant === "sheet") {
        style.backgroundColor = colors.content.container[getCommandSurfaceColor({
            surfaceColor: "default",
            variant
        })];
    }

    if(variant !== "dialog") {
        return style;
    }

    return {
        ...style,
        ...getCornerStyle({
            radius: radiuses.surface,
            shapeConfigs
        }),
        ...getSurfaceStyle({
            surface: "dialog",
            shadowAlpha,
            elevations,
            borders,
            colors
        }),
        maxWidth: windowWidth - spaces.spacingLg * 2,
        width: shapeConfigs.commandWidth
    };
};

const stylesheet = StyleSheet.create({
    status: {
        pointerEvents: "none",
        position: "absolute",
        overflow: "hidden",
        ...webStyle({
            clipPath: "inset(50%)",
            whiteSpace: "nowrap"
        })
    },
    container: {
        flexDirection: "column",
        minWidth: 0
    },
    dialogContainer: {
        borderStyle: "solid",
        flexShrink: 1
    },
    sheetContainer: {
        flexShrink: 1,
        flexGrow: 1
    }
});

export const useStyles = ({
    shapeConfigs,
    shadowAlpha,
    windowWidth,
    elevations,
    radiuses,
    borders,
    variant,
    colors,
    spaces
}: CommandDynamicStyleType) => {
    const styles = {
        container: getCommandSurfaceStyle({
            shapeConfigs,
            shadowAlpha,
            windowWidth,
            elevations,
            radiuses,
            borders,
            variant,
            colors,
            spaces
        }) as Mutable<ViewStyle>,
        status: {
            height: borders.line,
            width: borders.line
        } as Mutable<ViewStyle>
    };

    return styles;
};
export default stylesheet;
